import { ApiController } from '../controllers/ApiController.js';
import { ConstantsUtil } from './ConstantsUtil.js';
export const WalletUtil = {
    getWalletButton(wallet) {
        const walletButtonIds = ConstantsUtil.WalletButtonsIds;
        if (wallet in walletButtonIds) {
            return ApiController.state.walletButtons.find(walletButton => walletButton.id === walletButtonIds[wallet]);
        }
        return undefined;
    },
    isWalletButtonReady(wallet) {
        if (wallet in ConstantsUtil.WalletButtonsIds) {
            return Boolean(WalletUtil.getWalletButton(wallet));
        }
        return true;
    }
};
//# sourceMappingURL=WalletUtil.js.map